import { FunctionalComponent, h }           from 'preact';
import { useCallback, useEffect, useState } from 'preact/hooks';
import ImageButton                          from './imageButton';
import NewsFeed, { olympicJSON }            from './newsFeed';

type AppProps = {
	backgroundImage : string;
	backgroundColor : string;
	imagePlaceholder : string;
	prerollLinkSuffix : string;
	height : number;
	brandingSize : number;
	brandingLink : string;
	videoFeed : string;
	videoButton : string;
	newsFeed : string;
	newsButton : string;
}

const App : FunctionalComponent<AppProps> = ( props ) => {
		const [ videoFeed, setVideoFeed ] = useState<olympicJSON | undefined>( undefined );
		const [ newsFeed, setNewsFeed ] = useState<olympicJSON | undefined>( undefined );
		const [ buttonActive, setButtonActive ] = useState( 0 );
		const onButtonClick = useCallback( ( setActive : number ) => setButtonActive( setActive ), [ buttonActive ] );

		useEffect( () => {
			fetch( props.videoFeed, { cache : 'production' === process.env.NODE_ENV ? 'no-cache' : 'no-store' } ).then( res => res.json() ).then( ( result : olympicJSON ) => {
				setVideoFeed( result );
			} );
			fetch( props.newsFeed, { cache : 'production' === process.env.NODE_ENV ? 'no-cache' : 'no-store' } ).then( res => res.json() ).then( ( result : olympicJSON ) => {
				setNewsFeed( result );
			} );

			return () => {
				// cleanup??
			};
		}, [] );

		return (
			<div id='nbcolympicscomnews_root' style={{
				position         : 'relative',
				backgroundColor  : props.backgroundColor,
				backgroundImage  : 'url(' + props.backgroundImage + ')',
				backgroundRepeat : 'no-repeat',
				maxWidth         : 876,
				height           : props.height,
				padding          : `6px 12px 12px ${props.brandingSize}px`,
				boxSizing        : 'border-box',
				display          : 'flex',
				flexDirection    : 'column',
				justifyContent   : 'center',
				margin           : '0 auto',
			}}>

				<div style={{ marginBottom : 0 }}>
					{props.brandingLink && <a href={props.brandingLink} style={{
						width    : props.brandingSize,
						display  : 'block',
						position : 'absolute',
						top      : 0,
						height   : '100%',
						left     : 0
					}} />}
					<div style={{ height : 30, paddingBottom : 6, marginBottom : 0 }}>
						<ImageButton image={props.newsButton} label='Olympic News Articles' active={0 === buttonActive} onButtonClick={() => onButtonClick( 0 )} />
						<ImageButton image={props.videoButton} label='Olympic News Videos' active={1 === buttonActive} onButtonClick={() => onButtonClick( 1 )} />
					</div>
					<div style={{ backgroundColor : 'hsla( 0, 0%, 90%, 0.8 )', flex : '0', position : 'relative', marginBottom : 0 }}>
						{!videoFeed || !newsFeed ? <div>Loading...</div> : (
							0 === buttonActive
							? <NewsFeed data={newsFeed} linkSuffix={props.prerollLinkSuffix} placeholder={props.imagePlaceholder} />
							: <NewsFeed data={videoFeed} linkSuffix={props.prerollLinkSuffix} placeholder={props.imagePlaceholder} />
						)}
					</div>
				</div>
			</div>
		);
	}
;

export default App;